import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import styles from './Card.module.scss';
import utilityStyles from 'styles/global/utility.module.scss';

interface OwnProps {
  maxHeight?: number;
}

type CardProps = JSX.IntrinsicElements['div'] & OwnProps;

const Card: FunctionComponent<CardProps> = props => {
  const { className, maxHeight, ...rest } = props;

  const cardClassName = cx({
    [utilityStyles.elevation3]: true,
    [styles.card]: true,
    ...(className && { [className]: true }),
  });

  return <div className={cardClassName} {...rest} {...(maxHeight && { style: { height: `${maxHeight}px`, maxHeight: `${maxHeight}px` } })} />;
};

export default Card;
